// Links in rich text are restricted to our own platforms. Anything else stays
// plain text — in the editor, when rendering stored HTML and on autolink/paste.
//
// TWIN: m2-api/app/services/rich_text/link_policy.rb holds the same lists and
// rules for notes from the API. Change both in the same change, plus both test
// files (linkPolicy.test.ts / spec/services/rich_text/link_policy_spec.rb).
// If they drift, the backend rejects links the editor allows or vice versa.

// Registrable domains: the domain itself and every subdomain are allowed.
export const ALLOWED_LINK_DOMAINS = [
  'kanzleihohner.de',
  'm2-loesung.de',
  'hermine.ai',
  'talklegal.ai',
  'm2-akademie.de',
  'm2-konfliktloesung.de'
]

// Exact hosts only — used for tenants on shared platforms, where allowing the
// parent domain would open the door to every other tenant.
export const ALLOWED_LINK_HOSTS = ['m2akademie.sharepoint.com']

// The only class a link may carry; renders the link as a button.
export const LINK_BUTTON_CLASS = 'm2-link-button'

const hasScheme = (value: string) => /^[a-z][a-z0-9+.-]*:/i.test(value)

/** Trims user input and assumes https:// when no scheme was typed. */
export const normalizeLinkInput = (value: string): string => {
  const trimmed = value.trim()
  if (!trimmed) return ''
  return hasScheme(trimmed) ? trimmed : `https://${trimmed}`
}

export const isAllowedLinkUrl = (url?: string | null): boolean => {
  if (!url) return false

  let parsed: URL
  try {
    parsed = new URL(url)
  } catch {
    return false
  }

  if (parsed.protocol !== 'https:') return false
  if (parsed.username || parsed.password) return false

  // Compare the parsed hostname exactly — a substring match would let
  // "kanzleihohner.de.evil.com" through.
  const host = parsed.hostname.toLowerCase().replace(/\.$/, '')

  return (
    ALLOWED_LINK_HOSTS.includes(host) ||
    ALLOWED_LINK_DOMAINS.some(domain => host === domain || host.endsWith(`.${domain}`))
  )
}
